import { deletedata } from '@/util/global';
import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';

const  TableAmazonOrder = ({ rows }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(rows);

  const trows = [];
  for (let i = 0; i < view.length; i++) {
    const a = view[i];
    trows.push(
      <tr key={a._id || i}>
        <td>{a.AmazonOrderId ?? '—'}</td>
        <td>{a.PurchaseDate ?? '—'}</td>
        <td>{a.OrderStatus ?? '—'}</td>
        <td>{a.OrderTotal?.Amount ?? '—'}</td>
        <td>
          <a target="_blank" href={`https://sellercentral.amazon.in/orders-v3/order/${a.AmazonOrderId}`}>view</a>
        </td>
      </tr>
    );
  }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
    <>
      <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} />
      <table className="grid">
        <thead>
          <tr>
            {th('AmazonOrderId', 'amazon order id')}
            {th('PurchaseDate', 'purchase date')}
            {th('OrderStatus', 'status')}
            {th('OrderTotal', 'order total')}
            <th style={{ width: '80px' }}>action</th>
          </tr>
        </thead>
        <tbody>{trows}</tbody>
      </table>
    </>
  );
};

export default TableAmazonOrder;
